import React, { FC, ReactNode, useState } from 'react'

import get from 'lodash/get'
import { Field } from 'redux-form'

import classes from './Password.module.scss'
import ReduxFormInput from '../redux-form-input'
import ReduxFormInputTwo from '../redux-form-input-two'

interface PasswordProps {
  help?: ReactNode
  isShowing?: boolean
  label?: ReactNode
  onShowingChange?: () => void
  password?: string
  onChange?: (value: string) => void
  componentStyle?: 'one' | 'two'
  validate?: ((value: string) => string | undefined)[]
  dataTestId?: string
  className?: string
}

const Password: FC<PasswordProps> = ({
  help,
  isShowing,
  label = <>Password</>,
  onShowingChange,
  password,
  onChange,
  componentStyle = 'one',
  validate,
  dataTestId = 'password-input',
  className,
}) => {
  const [isLocalShowing, setIsLocalShowing] = useState(false)
  const isControlled = isShowing !== undefined && onShowingChange !== undefined
  const isPasswordShowing = isControlled ? isShowing : isLocalShowing
  const isTextShowing = isPasswordShowing ? 'Hide password' : 'Show password'
  const component = get(
    {
      one: ReduxFormInput,
      two: ReduxFormInputTwo,
    },
    componentStyle
  )

  return (
    <Field
      id="password"
      name="password"
      component={component}
      help={help}
      label={label}
      componentStyle={componentStyle}
      type={isPasswordShowing ? 'text' : 'password'}
      value={password}
      onChange={
        onChange as React.ChangeEventHandler<HTMLInputElement> | undefined
      }
      validate={validate}
      dataTestId={dataTestId}
      showToggle={
        <button
          tabIndex={0}
          onClick={() => {
            if (isControlled) {
              onShowingChange?.()
            } else {
              setIsLocalShowing((value) => !value)
            }
          }}
          type="button"
          data-testid="show-hide-password-button"
          className={[classes.toggleButton, className]
            .filter(Boolean)
            .join(' ')}
        >
          {isTextShowing}
        </button>
      }
    />
  )
}

export { Password }
export default Password
